<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Devices' : 'Deleted Devices'
                "
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/devices/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    hide-details="auto"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    hide-details="auto"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="device_status"
                    solo
                    rounded
                    v-model="filter.status"
                    :items="deviceStatuses"
                    hide-details="auto"
                    label="Device Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-cellphone"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="hospital"
                    solo
                    rounded
                    v-model="filter.hospital_id"
                    :items="hospitals"
                    item-text="name"
                    item-value="id"
                    label="Hospital"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-hospital-building"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="devices.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" :style="`height: ${tableHeight}px`">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="tableHeight"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start" style="min-width: none">
                        Serial Number
                      </th>
                      <th class="text-start">Model Name</th>
                      <th class="text-start">Device Status</th>
                      <th class="text-start">Hospital</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="devices.length != 0">
                    <tr
                      v-for="(device, i) in devices"
                      :key="`device_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': devices.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="device.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Device is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="device.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Device is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ device.serial_number || "" }}
                      </td>
                      <td>
                        {{ device.model_name || "" }}
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="getDeviceStatusColor(device.status)"
                          text-color="white"
                        >
                          {{ getDeviceStatusText(device.status) }}
                        </v-chip>
                      </td>
                      <td>
                        {{ device.hospital ? device.hospital.name : "" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(device.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Device</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/devices/${encryptIt(device.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Device</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(device.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this device</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_device" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Device deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_device = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_device" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Device restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_device = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "devicesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        status: "",
        hospital_id: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_device: false,
      is_restored_device: false,
      devices: [],
      hospitals: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      deviceStatuses: [
        {
          id: 0,
          text: "All Status",
          value: "",
        },
        { id: "AVAILABLE", text: "AVAILABLE", value: "0" },
        { id: "ASSIGNED", text: "ASSIGNED", value: "1" },
        { id: "UNDER_MAINTENANCE", text: "UNDER MAINTENANCE", value: "2" },
      ],
      isLoading: false,
      isExcelloading: false,
    };
  },
  computed: {
    tableHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 250; // Mobile phones
        case 'sm': return 300; // Tablets
        case 'md': return 400; // Small laptops
        case 'lg': return 500; // Desktop
        case 'xl': return 600; // Large desktop
        default: return 400;
      }
    }
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getHospitals();
  },
  methods: {
    isDeletePage() {
      return this.$route.query.open_trash ? true : false;
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.hospital_id = this.filter.hospital_id
        ? this.filter.hospital_id
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&hospital_id=" +
        this.filter.hospital_id +
        "&search_keyword=" +
        this.filter.search_keyword;

      await axios
        .get(`devices?${query}`)
        .then((response) => {
          this.devices = response.data.data;
          this.count = response.data.count;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    async getHospitals() {
      await axios
        .get("devices/hospitals")
        .then((response) => {
          this.hospitals = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async Delete_this(id) {
      await axios
        .post(`/devices/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_device = true;
          this.getData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async Restore_this(id) {
      await axios
        .post(`/devices/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.is_restored_device = true;
          this.getData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.hospital_id = this.filter.hospital_id
        ? this.filter.hospital_id
        : "";
      let query =
        "is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&hospital_id=" +
        this.filter.hospital_id +
        "&search_keyword=" +
        this.filter.search_keyword;

      try {
        const response = await axios.get(`devices/excel?${query}`, {
          responseType: 'blob'
        });
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'devices.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.log("Excel export error:", error);
      }
      
      this.isExcelloading = false;
    },
    getDeviceStatusText(status) {
      switch (status) {
        case 0:
          return "Available";
        case 1:
          return "Assigned";
        case 2:
          return "Under Maintenance";
        default:
          return "Unknown";
      }
    },
    getDeviceStatusColor(status) {
      switch (status) {
        case 0:
          return "success";
        case 1:
          return "primary";
        case 2:
          return "warning";
        default:
          return "secondary";
      }
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.table-row-even {
  background-color: #f9f9f9;
}
.table-row-odd {
  background-color: white;
}
.sr_no {
  min-width: 85px;
}
</style>